// 表示確認モード（Issue #46）。
//
// 現行のフリーページには `?check=` を付けると全状態が縦に並び、<select> で切り替えられる仕掛けが入っている
// （`c.mode == -1`）。同じ役割をウィジェット側に持たせたもの。
//
// ★★このモードでは API を一切叩かない。
//   発行ボタンを押すと**お客様へ本物の領収書メールが飛ぶ**ので、表示を確かめるだけの経路を
//   ネットワークから完全に切り離しておく必要がある（index.ts は preview が立っていたら
//   fetchOrderInfo も issueReceipt も呼ばない）。
//
// 使い方:
//   ?wu_receipt_preview=issue     発行画面
//   ?wu_receipt_preview=done      送信完了
//   ?wu_receipt_preview=reissue   再送信
//   ?wu_receipt_preview=sending   処理中
//   ?wu_receipt_preview=error     エラー
//   ?wu_receipt_preview=notfound  guid が無い・受注が見つからない
//   ?wu_receipt_preview=all       全部を縦に並べる（現行の mode -1 にあたる）

import type { State, ViewModel } from './template'

export const PREVIEW_PARAM = 'wu_receipt_preview'

/** 全状態を縦に並べる指定 */
export const PREVIEW_ALL = 'all'

const STATES: Record<string, State> = {
  issue: 'issue',
  done: 'done',
  reissue: 'reissue',
  sending: 'sending',
  error: 'error',
  notfound: 'notFound',
}

/** 並べる順。現行のフリーページの並び（発行 → 完了 → 再送信 → 処理中 → エラー）に合わせる。 */
export const PREVIEW_ORDER: State[] = ['issue', 'done', 'reissue', 'sending', 'error', 'notFound']

/**
 * ★作り物の受注。**実在の顧客の氏名・メールアドレス・受注番号を入れないこと**（Issue #46 の「守ること」）。
 *   見た目の確認に要るのは「長さ」と「桁」なので、それが分かるダミーで足りる。
 */
export const PREVIEW_ORDER_INFO: ViewModel = {
  siteName: '【表示確認】サンプルストア',
  orderNo: 999999,
  name: '株式会社サンプル 経理部',
  price: 1234567,
  date: '2026年09月17日',
  mailAddress: 'sample@example.com',
}

/**
 * 別注版のダウンロードリンクに入れる作り物の guid。実在しない値なので、押しても PDF は出ない
 * （リンクの形を確かめるためのもの）。
 */
export const PREVIEW_GUID = '00000000-0000-0000-0000-000000000000'

export type Preview = { kind: 'one'; state: State } | { kind: 'all' }

/** URL のクエリから表示確認モードを読む。指定が無い／知らない値なら null（＝通常動作）。 */
export function readPreview(search: string): Preview | null {
  const raw = new URLSearchParams(search).get(PREVIEW_PARAM)
  if (raw === null) return null

  const v = raw.trim().toLowerCase()
  if (v === PREVIEW_ALL) return { kind: 'all' }

  const state = STATES[v]
  return state ? { kind: 'one', state } : null
}

/** 状態の見出し（どれを見ているかが分かるように出す）。 */
export const PREVIEW_LABEL: Record<State, string> = {
  issue: '発行画面（現行 mode 1）',
  done: '送信完了（現行 mode 2）',
  reissue: '再送信画面（現行 mode 3）',
  sending: '処理中（現行 mode 4）',
  error: 'エラー（現行 mode 5）',
  notFound: '受注が見つからない（現行は真っ白。このウィジェットで追加）',
}
